import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as Badge } from './Badge.vue';

export const badgeVariants = cva(
    'inline-flex items-center justify-center rounded-md border px-2 py-1 text-xs font-semibold w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden',
    {
        variants: {
            variant: {
                default:
                    'border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
                secondary:
                    'border-transparent text-secondary-foreground [a&]:hover:bg-secondary/90',
                destructive:
                    'border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
                outline:
                    'text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
            },
            color: {
                blue: '',
                apricot: '',
                purple: '',
                green: '',
                yellow: '',
            },
        },
        compoundVariants: [
            {
                variant: 'secondary',
                color: 'blue',
                class: 'bg-secondary hover:bg-secondary/90',
            },
            {
                variant: 'secondary',
                color: 'apricot',
                class: 'bg-apricot-100 hover:bg-apricot-100/90',
            },
            {
                variant: 'secondary',
                color: 'purple',
                class: 'bg-purple-100 hover:bg-purple-100/90',
            },
            {
                variant: 'secondary',
                color: 'green',
                class: 'bg-green-100 hover:bg-green-100/90',
            },
            {
                variant: 'secondary',
                color: 'yellow',
                class: 'bg-yellow-100 hover:bg-yellow-100/90',
            },
        ],
        defaultVariants: {
            variant: 'default',
            color: 'blue',
        },
    }
);
export type BadgeVariants = VariantProps<typeof badgeVariants>;
